// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-invite {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin-bottom: 0.65rem;
}

.dp-invite__toggle {
  appearance: none;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  width: 100%;
  text-align: left;
  padding: 0.7rem 0.85rem;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  color: var(--dp-text, #e8eef8);
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;
}

.dp-invite__toggle:hover {
  background: color-mix(in srgb, var(--dp-primary, #0877bc) 18%, transparent);
  border-color: color-mix(in srgb, var(--dp-accent, #67e8f9) 32%, transparent);
}

.dp-invite__toggle:focus-visible {
  outline: 2px solid #67e8f9;
  outline-offset: 2px;
}

.dp-invite__toggle-copy {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
  min-width: 0;
  flex: 1 1;
}

.dp-invite__toggle-copy strong {
  font-size: 0.86rem;
  font-weight: 700;
}

.dp-invite__toggle-copy span {
  font-size: 0.72rem;
  color: var(--dp-muted, #94a3b8);
  line-height: 1.35;
}

.dp-invite__chevron {
  color: var(--dp-muted, #94a3b8);
  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1);
}

.dp-invite--open .dp-invite__chevron {
  transform: rotate(180deg);
}

.dp-invite__panel {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  max-height: min(42vh, calc(var(--dp-vvh, 100dvh) * 0.42), 360px);
  overflow: auto;
  padding: 0.75rem 0.8rem 0.85rem;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 23, 42, 0.72);
  animation: digipingSlideUp 0.28s cubic-bezier(0.25, 1, 0.5, 1);
}

.dp-invite__note {
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.45;
  color: var(--dp-muted, #94a3b8);
}

.dp-invite__table {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.dp-invite__chips {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.dp-invite__chip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.45rem 0.55rem 0.45rem 0.75rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  color: var(--dp-text, #e8eef8);
  font-size: 0.82rem;
  line-height: 1.35;
}

.dp-invite__chip span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dp-invite__draft {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.dp-invite__draft input {
  width: 100%;
  min-width: 0;
  padding: 0.7rem 0.75rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: var(--dp-text, #e8eef8);
  font-family: inherit;
  font-size: 1rem;
  scroll-margin-bottom: 1.5rem;
}

.dp-invite__head,
.dp-invite__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.3fr) 36px;
  gap: 0.4rem;
  align-items: center;
}

.dp-invite__head {
  padding: 0 0.15rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #cbd5e1;
}

.dp-invite__row input {
  width: 100%;
  min-width: 0;
  padding: 0.55rem 0.65rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: var(--dp-text, #e8eef8);
  font-family: inherit;
  font-size: 0.88rem;
}

.dp-invite__draft input::placeholder {
  color: #64748b;
}

.dp-invite__draft input:focus {
  outline: none;
  border-color: color-mix(in srgb, var(--dp-primary, #0877bc) 70%, #fff);
  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.22);
}

.dp-invite__icon-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #94a3b8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.dp-invite__icon-btn:hover:not(:disabled) {
  background: rgba(248, 113, 113, 0.16);
  color: #fecaca;
}

.dp-invite__icon-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.dp-invite__row-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
}

.dp-invite__link {
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  border: none;
  background: transparent;
  color: #67e8f9;
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 650;
  cursor: pointer;
  padding: 0.2rem 0;
}

.dp-invite__link:hover:not(:disabled) {
  text-decoration: underline;
}

.dp-invite__link:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.dp-invite__paste {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.dp-invite__paste textarea {
  width: 100%;
  resize: vertical;
  min-height: 84px;
  padding: 0.65rem 0.75rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  color: var(--dp-text, #e8eef8);
  font-family: inherit;
  font-size: 0.86rem;
  line-height: 1.45;
}

.dp-invite__paste textarea:focus {
  outline: none;
  border-color: color-mix(in srgb, var(--dp-primary, #0877bc) 70%, #fff);
}

.dp-invite__secondary,
.dp-invite__send {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  border: none;
  border-radius: 10px;
  font-family: inherit;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.2s ease;
}

.dp-invite__secondary {
  align-self: flex-start;
  padding: 0.45rem 0.8rem;
  background: rgba(255, 255, 255, 0.08);
  color: #e8eef8;
}

.dp-invite__send {
  width: 100%;
  padding: 0.7rem 1rem;
  background: var(--dp-primary-gradient, linear-gradient(135deg, #0877bc, #065a8f));
  color: #fff;
}

.dp-invite__send:hover:not(:disabled),
.dp-invite__secondary:hover:not(:disabled) {
  transform: scale(1.02);
}

.dp-invite__send:active:not(:disabled),
.dp-invite__secondary:active:not(:disabled) {
  transform: scale(0.98);
}

.dp-invite__send:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dp-invite__error {
  margin: 0;
  color: #fca5a5;
  font-size: 0.8rem;
}

.dp-invite__success {
  margin: 0;
  color: #6ee7b7;
  font-size: 0.8rem;
  line-height: 1.4;
}

.dp-invite__col-action {
  width: 36px;
}

.dp-invite .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 640px) {
  .dp-invite__head {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AICoach/DigipingPlayerInviteRoster.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,8BAA8B;EAC9B,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,2EAA2E;EAC3E,4EAA4E;AAC9E;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gEAAgE;EAChE,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,8DAA8D;AAChE;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,wCAAwC;EACxC,mBAAmB;EACnB,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;EAEE,aAAa;EACb,0EAA0E;EAC1E,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sEAAsE;AACxE;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iFAAiF;EACjF,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".dp-invite {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  margin-bottom: 0.65rem;\n}\n\n.dp-invite__toggle {\n  appearance: none;\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  width: 100%;\n  text-align: left;\n  padding: 0.7rem 0.85rem;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--dp-text, #e8eef8);\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;\n}\n\n.dp-invite__toggle:hover {\n  background: color-mix(in srgb, var(--dp-primary, #0877bc) 18%, transparent);\n  border-color: color-mix(in srgb, var(--dp-accent, #67e8f9) 32%, transparent);\n}\n\n.dp-invite__toggle:focus-visible {\n  outline: 2px solid #67e8f9;\n  outline-offset: 2px;\n}\n\n.dp-invite__toggle-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.12rem;\n  min-width: 0;\n  flex: 1;\n}\n\n.dp-invite__toggle-copy strong {\n  font-size: 0.86rem;\n  font-weight: 700;\n}\n\n.dp-invite__toggle-copy span {\n  font-size: 0.72rem;\n  color: var(--dp-muted, #94a3b8);\n  line-height: 1.35;\n}\n\n.dp-invite__chevron {\n  color: var(--dp-muted, #94a3b8);\n  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.dp-invite--open .dp-invite__chevron {\n  transform: rotate(180deg);\n}\n\n.dp-invite__panel {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  max-height: min(42vh, calc(var(--dp-vvh, 100dvh) * 0.42), 360px);\n  overflow: auto;\n  padding: 0.75rem 0.8rem 0.85rem;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(15, 23, 42, 0.72);\n  animation: digipingSlideUp 0.28s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.dp-invite__note {\n  margin: 0;\n  font-size: 0.78rem;\n  line-height: 1.45;\n  color: var(--dp-muted, #94a3b8);\n}\n\n.dp-invite__table {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.dp-invite__chips {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.dp-invite__chip {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.45rem 0.55rem 0.45rem 0.75rem;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--dp-text, #e8eef8);\n  font-size: 0.82rem;\n  line-height: 1.35;\n}\n\n.dp-invite__chip span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dp-invite__draft {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.dp-invite__draft input {\n  width: 100%;\n  min-width: 0;\n  padding: 0.7rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--dp-text, #e8eef8);\n  font-family: inherit;\n  font-size: 1rem;\n  scroll-margin-bottom: 1.5rem;\n}\n\n.dp-invite__head,\n.dp-invite__row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.3fr) 36px;\n  gap: 0.4rem;\n  align-items: center;\n}\n\n.dp-invite__head {\n  padding: 0 0.15rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #cbd5e1;\n}\n\n.dp-invite__row input {\n  width: 100%;\n  min-width: 0;\n  padding: 0.55rem 0.65rem;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--dp-text, #e8eef8);\n  font-family: inherit;\n  font-size: 0.88rem;\n}\n\n.dp-invite__draft input::placeholder {\n  color: #64748b;\n}\n\n.dp-invite__draft input:focus {\n  outline: none;\n  border-color: color-mix(in srgb, var(--dp-primary, #0877bc) 70%, #fff);\n  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.22);\n}\n\n.dp-invite__icon-btn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #94a3b8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.dp-invite__icon-btn:hover:not(:disabled) {\n  background: rgba(248, 113, 113, 0.16);\n  color: #fecaca;\n}\n\n.dp-invite__icon-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.dp-invite__row-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.55rem;\n}\n\n.dp-invite__link {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  border: none;\n  background: transparent;\n  color: #67e8f9;\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 650;\n  cursor: pointer;\n  padding: 0.2rem 0;\n}\n\n.dp-invite__link:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.dp-invite__link:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.dp-invite__paste {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.dp-invite__paste textarea {\n  width: 100%;\n  resize: vertical;\n  min-height: 84px;\n  padding: 0.65rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--dp-text, #e8eef8);\n  font-family: inherit;\n  font-size: 0.86rem;\n  line-height: 1.45;\n}\n\n.dp-invite__paste textarea:focus {\n  outline: none;\n  border-color: color-mix(in srgb, var(--dp-primary, #0877bc) 70%, #fff);\n}\n\n.dp-invite__secondary,\n.dp-invite__send {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  border: none;\n  border-radius: 10px;\n  font-family: inherit;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.2s ease;\n}\n\n.dp-invite__secondary {\n  align-self: flex-start;\n  padding: 0.45rem 0.8rem;\n  background: rgba(255, 255, 255, 0.08);\n  color: #e8eef8;\n}\n\n.dp-invite__send {\n  width: 100%;\n  padding: 0.7rem 1rem;\n  background: var(--dp-primary-gradient, linear-gradient(135deg, #0877bc, #065a8f));\n  color: #fff;\n}\n\n.dp-invite__send:hover:not(:disabled),\n.dp-invite__secondary:hover:not(:disabled) {\n  transform: scale(1.02);\n}\n\n.dp-invite__send:active:not(:disabled),\n.dp-invite__secondary:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.dp-invite__send:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.dp-invite__error {\n  margin: 0;\n  color: #fca5a5;\n  font-size: 0.8rem;\n}\n\n.dp-invite__success {\n  margin: 0;\n  color: #6ee7b7;\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n.dp-invite__col-action {\n  width: 36px;\n}\n\n.dp-invite .sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n@media (max-width: 640px) {\n  .dp-invite__head {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
